export const selectTemplates = (state) => state.templates.templates;
export const selectCurrentTemplate = (state) => state.templates.currentTemplate;
export const selectTemplatesLoading = (state) => state.templates.loading;
export const selectTemplatesError = (state) => state.templates.error;
export const selectShowRemoved = (state) => state.templates.showRemoved;
export const selectPagination = (state) => state.templates.pagination;
export const selectFilters = (state) => state.templates.filters;
